import { render, staticRenderFns } from "./SearchOld.vue?vue&type=template&id=d2e0e8a0&scoped=true&"
import script from "./SearchOld.vue?vue&type=script&lang=js&"
export * from "./SearchOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e0e8a0",
  null
  
)

export default component.exports